import React, { JSX } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import ResetPasswordWindow from "./Modules/ResetPasswordWindow";
import SendEmailWindow from "./Modules/SendEmailWindow";
import { ForgotLogoBlock, ForgotPage, LogoIcon, LogoTitle } from "./styled";

interface IRoutes {
  path: string;
  element: JSX.Element;
}

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate("/authorization");
  };

  const ROUTES: IRoutes[] = [
    {
      path: "/",
      element: <SendEmailWindow handleReturn={handleReturn} />,
    },
    { path: `/:resetKey`, element: <ResetPasswordWindow /> },
  ];

  return (
    <ForgotPage>
      <ForgotLogoBlock>
        <LogoIcon />
        <LogoTitle />
      </ForgotLogoBlock>
      <Routes>
        {ROUTES.map((route) => (
          <Route path={route.path} element={route.element} key={route.path} />
        ))}
      </Routes>
    </ForgotPage>
  );
};

export default ForgotPasswordPage;
